import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Empregador, EventoAuditoria, Funcionario } from '../../api.service';
import { ModalPesquisaFuncionarioComponent } from '../funcionario/modal-pesquisa-funcionario.component';
import { ServicoBuscaCadastro } from '../../shared/servico-busca-cadastro';
import { GradeEventosAuditoriaComponent } from './grade-eventos-auditoria.component';
import { ModalCapturaPontoComponent } from './modal-captura-ponto.component';
import { PainelFiltrosAuditoriaComponent } from './painel-filtros-auditoria.component';
import { OpcaoAuditoria, ServicoAuditoriaAdministrativa } from './servico-auditoria-administrativa';

@Component({
  selector: 'app-tela-auditoria',
  standalone: true,
  imports: [
    CommonModule,
    GradeEventosAuditoriaComponent,
    ModalCapturaPontoComponent,
    ModalPesquisaFuncionarioComponent,
    PainelFiltrosAuditoriaComponent
  ],
  templateUrl: './tela-auditoria.component.html'
})
export class TelaAuditoriaComponent implements OnChanges, OnDestroy {
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';
  @Input() funcionarios: Funcionario[] = [];

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() mensagem = new EventEmitter<string>();

  private readonly filtroPadrao = this.servicoAuditoriaAdministrativa.filtroPadrao();

  eventos: EventoAuditoria[] = [];
  dataInicial = this.filtroPadrao.dataInicial;
  dataFinal = this.filtroPadrao.dataFinal;
  tipoSelecionado = this.filtroPadrao.tipo;
  statusSelecionado = this.filtroPadrao.status;
  funcionarioSelecionado = '';
  buscaFuncionario = '';
  buscaFuncionarioModal = '';
  modalFuncionariosAberta = false;
  limite = this.filtroPadrao.limite;
  pagina = 1;
  totalElementos = 0;
  totalPaginas = 0;
  carregando = false;
  capturaAberta = false;
  capturaCarregando = false;
  capturaUrl = '';
  capturaTitulo = 'Captura facial';
  capturaAviso = '';
  capturaErro = '';
  tiposAuditoria: OpcaoAuditoria[] = this.servicoAuditoriaAdministrativa.tiposAuditoria();
  statusAuditoria: OpcaoAuditoria[] = this.servicoAuditoriaAdministrativa.statusAuditoria();

  constructor(
    private readonly servicoAuditoriaAdministrativa: ServicoAuditoriaAdministrativa,
    private readonly servicoBuscaCadastro: ServicoBuscaCadastro
  ) {}

  ngOnDestroy() {
    this.fecharCaptura();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['empregadorSelecionado']) {
      if (!changes['empregadorSelecionado'].firstChange) {
        this.limparFuncionario(false);
      }
      this.recarregar();
    }

    if (this.funcionarioSelecionado && !this.funcionarios.some(item => item.id === this.funcionarioSelecionado)) {
      this.limparFuncionario(true);
    }
  }

  get funcionariosFiltrados() {
    return this.servicoBuscaCadastro.filtrarFuncionarios(
      this.funcionarios,
      this.buscaFuncionario,
      this.funcionarioSelecionado
    );
  }

  get funcionariosModal() {
    return this.servicoBuscaCadastro.listarFuncionariosModal(this.funcionarios, this.buscaFuncionarioModal);
  }

  rotuloFuncionario = (item: unknown) => this.servicoBuscaCadastro.rotuloFuncionario(item);

  detalheFuncionario = (item: unknown) => this.servicoBuscaCadastro.detalheFuncionario(item);

  selecionarEmpregador(empregadorId: string) {
    this.empregadorSelecionado = empregadorId;
    this.empregadorSelecionadoChange.emit(empregadorId);
    this.limparFuncionario(false);
    this.recarregar();
  }

  alterarDataInicial(data: string) {
    const padrao = this.servicoAuditoriaAdministrativa.filtroPadrao().dataInicial;
    this.dataInicial = data || padrao;
    if (this.dataFinal < this.dataInicial) {
      this.dataFinal = this.dataInicial;
    }
    this.recarregar();
  }

  alterarDataFinal(data: string) {
    const padrao = this.servicoAuditoriaAdministrativa.filtroPadrao().dataFinal;
    this.dataFinal = data || padrao;
    if (this.dataFinal < this.dataInicial) {
      this.dataInicial = this.dataFinal;
    }
    this.recarregar();
  }

  alterarTipo(tipo: string) {
    this.tipoSelecionado = tipo;
    this.recarregar();
  }

  alterarStatus(status: string) {
    this.statusSelecionado = status || this.servicoAuditoriaAdministrativa.filtroPadrao().status;
    this.recarregar();
  }

  alterarBuscaFuncionario(valor: string) {
    const tinhaSelecao = !!this.funcionarioSelecionado;
    this.buscaFuncionario = valor;
    if (this.funcionarioSelecionado && !this.buscaConfereFuncionarioSelecionado()) {
      this.funcionarioSelecionado = '';
    }

    if (!valor.trim()) {
      this.limparFuncionario(tinhaSelecao);
      return;
    }

    if (valor.trim().length < 3) {
      if (tinhaSelecao && !this.funcionarioSelecionado) {
        this.recarregar();
      }
      return;
    }

    if (this.funcionariosFiltrados.length === 1) {
      this.selecionarFuncionario(this.funcionariosFiltrados[0], false);
    }
  }

  abrirModalFuncionarios() {
    this.buscaFuncionarioModal = '';
    this.modalFuncionariosAberta = true;
  }

  fecharModalFuncionarios() {
    this.buscaFuncionarioModal = '';
    this.modalFuncionariosAberta = false;
  }

  limparBuscaFuncionarioModal() {
    this.buscaFuncionarioModal = '';
  }

  selecionarFuncionario(item: unknown, fecharModal = true) {
    const funcionario = item as Funcionario;
    this.funcionarioSelecionado = funcionario.id || '';
    this.buscaFuncionario = this.rotuloFuncionario(funcionario);
    this.buscaFuncionarioModal = '';
    if (fecharModal) {
      this.fecharModalFuncionarios();
    }
    this.recarregar();
  }

  alterarLimite(limite: number) {
    this.limite = limite;
    this.recarregar();
  }

  irParaPagina(pagina: number) {
    if (pagina < 1 || (this.totalPaginas > 0 && pagina > this.totalPaginas) || pagina === this.pagina) {
      return;
    }
    this.pagina = pagina;
    this.carregarEventos();
  }

  resumoFiltro() {
    const inicio = this.servicoAuditoriaAdministrativa.dataIsoParaBr(this.dataInicial);
    const fim = this.servicoAuditoriaAdministrativa.dataIsoParaBr(this.dataFinal);
    const periodo = this.dataInicial === this.dataFinal ? inicio : `${inicio} a ${fim}`;
    const tipo = this.tipoSelecionado
      ? this.servicoAuditoriaAdministrativa.rotuloTipo(this.tipoSelecionado)
      : 'Todos os tipos';
    const servidor = this.servicoAuditoriaAdministrativa.consultaServidor(
      this.buscaFuncionario,
      this.funcionarioSelecionado
    );
    const recorteServidor = servidor ? ` · servidor ${servidor}` : '';
    const status = this.servicoAuditoriaAdministrativa.rotuloStatus(this.statusSelecionado);
    return `Eventos de ${periodo} · ${tipo} · ${status}${recorteServidor}`;
  }

  recarregar() {
    this.pagina = 1;
    this.carregarEventos();
  }

  abrirCaptura(evento: EventoAuditoria) {
    const nsr = this.servicoAuditoriaAdministrativa.nsrDoEvento(evento);
    const empregadorId = evento.empregadorId || this.empregadorSelecionado;
    if (!empregadorId) {
      return;
    }

    this.limparUrlCaptura();
    this.capturaAberta = true;
    this.capturaCarregando = true;
    this.capturaErro = '';
    this.capturaAviso = '';

    if (nsr != null) {
      this.capturaTitulo = `Captura NSR ${nsr}`;
      this.capturaAviso = this.servicoAuditoriaAdministrativa.avisoMiniaturaCaptura();
      this.servicoAuditoriaAdministrativa.buscarCaptura(empregadorId, nsr).subscribe({
        next: blob => this.exibirCaptura(blob),
        error: () => this.falharCaptura(false)
      });
      return;
    }

    if (!evento.temCapturaFacial || !evento.id) {
      this.falharCaptura(true);
      return;
    }

    this.capturaTitulo = 'Captura da tentativa recusada';
    this.capturaAviso = this.servicoAuditoriaAdministrativa.avisoMiniaturaCaptura();
    this.servicoAuditoriaAdministrativa.buscarCapturaFalha(empregadorId, evento.id).subscribe({
      next: blob => this.exibirCaptura(blob),
      error: () => this.falharCaptura(true)
    });
  }

  private exibirCaptura(blob: Blob) {
    this.capturaUrl = URL.createObjectURL(blob);
    this.capturaCarregando = false;
  }

  private falharCaptura(falhaForaHorario: boolean) {
    this.capturaCarregando = false;
    this.capturaErro = this.servicoAuditoriaAdministrativa.mensagemErroCarregarCaptura(falhaForaHorario);
  }

  fecharCaptura() {
    this.capturaAberta = false;
    this.capturaCarregando = false;
    this.capturaErro = '';
    this.capturaAviso = '';
    this.limparUrlCaptura();
  }

  carregarEventos() {
    this.carregando = true;
    this.servicoAuditoriaAdministrativa.listar(
      this.empregadorSelecionado,
      this.tipoSelecionado,
      this.limite,
      this.dataInicial,
      this.dataFinal,
      this.buscaFuncionario,
      this.pagina,
      this.funcionarioSelecionado,
      this.statusSelecionado
    ).subscribe({
      next: pagina => {
        this.eventos = pagina.conteudo;
        this.pagina = pagina.pagina;
        this.totalElementos = pagina.totalElementos;
        this.totalPaginas = pagina.totalPaginas;
        this.carregando = false;
      },
      error: () => {
        this.carregando = false;
        this.mensagem.emit(this.servicoAuditoriaAdministrativa.mensagemErroCarregarEventos());
      }
    });
  }

  private limparFuncionario(recarregar: boolean) {
    this.funcionarioSelecionado = '';
    this.buscaFuncionario = '';
    this.buscaFuncionarioModal = '';
    if (recarregar) {
      this.recarregar();
    }
  }

  private buscaConfereFuncionarioSelecionado() {
    if (!this.funcionarioSelecionado) {
      return false;
    }
    const funcionario = this.funcionarios.find(item => item.id === this.funcionarioSelecionado);
    return !!funcionario && this.buscaFuncionario.trim() === this.rotuloFuncionario(funcionario);
  }

  private limparUrlCaptura() {
    if (this.capturaUrl) {
      URL.revokeObjectURL(this.capturaUrl);
      this.capturaUrl = '';
    }
  }
}
